import React, { useMemo, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';
import theme from '@styles/theme';
const { colors } = theme;

const baseStyle = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '20px',
  borderWidth: 2,
  borderRadius: 2,
  borderColor: '#eeeeee',
  borderStyle: 'dashed',
  backgroundColor: '#fafafa',
  color: '#bdbdbd',
  outline: 'none',
  transition: 'border .24s ease-in-out',
  cursor: 'pointer',
};

const activeStyle = {
  borderColor: '#2196f3',
};

const acceptStyle = {
  borderColor: '#00e676',
};

const rejectStyle = {
  borderColor: '#ff1744',
};

const FileUpload = ({ setFiles, errors, setErrors }) => {
  const onDrop = useCallback(acceptedFiles => {
    setFiles(acceptedFiles);
    const { 'resume': removedError, ...rest } = errors;
    setErrors({
      ...rest,
    });
  }, []);

  const {
    acceptedFiles,
    fileRejections,
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    accept: '.html,.text,.txt,.pdf,.doc,.docx,.rtf,.odt',
    onDrop,
  });

  const acceptedFileItems = acceptedFiles.map(file => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
    </li>
  ));

  const fileRejectionItems = fileRejections.map(({ file, errors }) => (
    <li key={file.path}>
      {file.path} - {file.size} bytes
      <ul>
        {errors.map(e => (
          <li key={e.code}>{e.message}</li>
        ))}
      </ul>
    </li>
  ));

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept],
  );

  return (
    <FileUploadContainer>
      <div {...getRootProps({ style, className: 'dropzone' })}>
        <input {...getInputProps()} />
        <p className="file-drop-text">Choose a file</p>
        <em className="file-drop-text-link">or click to browse</em>
      </div>
      <aside>
        <NoticeText>Accepted Resume types are html,text,txt,pdf,doc,docx,rtf,odt</NoticeText>
        <AcceptedText>{acceptedFileItems}</AcceptedText>
        <RejectedText>{fileRejectionItems}</RejectedText>
      </aside>
    </FileUploadContainer>
  );
};

export default FileUpload;

const FileUploadContainer = styled.div`
  background: ${colors.white};
  font-size: 14px;
  .dropzone {
    &:hover {
      border-color: ${colors.lightPurple} !important;
    }
    .file-drop-text-link {
      color: ${colors.lightPurple};
      text-decoration: underline;
    }
  }
`;

const NoticeText = styled.div`
  font-size: 14px;
`;

const AcceptedText = styled.ul`
  color: ${colors.lightPurple};
  list-style: none;
  li:before {
    content: '✓';
    color: ${colors.lightPurple};
    font-weight: bold;
    padding-right: 10px;
  }
`;

const RejectedText = styled.ul`
  color: ${colors.black};
  color: red;
  ul {
    display: none;
  }
`;
